import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { IRiskOption } from "src/core/constants/options";
import {
  ListElement,
  ListElementWithRisk,
  useActivitiesWithRiskListQuery,
} from "src/core/gql/graphql";
import { mapActivitiesToRiskOptions } from "src/core/mappers/activity-risk.mapper";

export const useActivityWithRiskOptions = (): {
  activityWithRiskOptions: IRiskOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: activityWithRiskList, loading, error } = useActivitiesWithRiskListQuery();

  const activityWithRiskOptions: IRiskOption[] = useMemo(() => {
    if (!activityWithRiskList?.listElements) return [];

    const activities = activityWithRiskList.listElements.filter(
      (element): element is ListElementWithRisk & ListElement =>
        "riskValues" in element && Array.isArray(element.riskValues)
    );

    const options = mapActivitiesToRiskOptions(activities);

    return options;
  }, [activityWithRiskList]);

  return { activityWithRiskOptions, loading, error };
};
